import React, { Component } from 'react';
import PurchaseMoreEntity from '.';
import { getInformation } from './query';
import Loading from '../../components/Loading';
import CustomView from './customView';

class PurchaseMoreEntityContainer extends Component {
    constructor() {
        super();

        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.showPlanInfo = this.showPlanInfo.bind(this);

        this.urlParams = new URLSearchParams(window.location.search);
        this.part = this.urlParams.get('part');

        this.state = {
            allData: [],
            isLoading: true,
            selectedCollapse: this.part ?? null,
            paymentInformation: null,
        };
    }

    async componentDidMount() {
        try {
            const res = await getInformation();
            const data = await res.json();
            this.setState({
                allData: data.result,
                isLoading: false,
                selectedCollapse: this.state.selectedCollapse ?? data.result[0]?.object_name,
                is_viewer: data.is_viewer,
                main_user_email: data?.main_user_email,
                paymentInformation: data?.purchased_information
                    ? JSON.parse(data?.purchased_information)
                    : null,
            });
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                isLoading: false,
            });
        }
    }

    showKey(key) {
        return key?.replace(/_/g, ' ')?.replace(/price/g, '');
    }

    showPlanInfo() {
        let info = [];
        const paymentInformation = this.state.paymentInformation;
        if (!paymentInformation) return null;
        const data = Object.entries(paymentInformation);
        const currentPlan = data.splice(0, 1);
        const currentPlanBox = (
            <div
                key={currentPlan?.[0]?.[0]}
                className="text-capitalize  settings-plan-content-items"
            >
                <span>Current Plan:</span> {this.state.allData?.[0]?.plan ?? '-'}
            </div>
        );

        info.push(currentPlanBox);
        data.forEach((item) => {
            const value = (
                <div key={item[0]} className="text-capitalize settings-plan-content-items">
                    <span>{this.showKey(item[0])}</span> Quantity: {item[1]?.quantity ?? 0}
                </div>
            );
            info.push(value);
        });

        return info;
    }

    showOpened(name, value) {
        return this.state.selectedCollapse === name ? value ?? 'active' : '';
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: this.state.selectedCollapse === id ? null : id,
        });
    }

    render() {
        console.log('this.state.allData', this.state.allData);
        return (
            <div className="purchase-container">
                {!this.props.fromOnboard && (
                    <div className="settings-plan">
                        <div className="settings-plan-content">
                            <div>{this.state.isLoading ? <Loading /> : this.showPlanInfo()}</div>
                        </div>
                    </div>
                )}
                {this.state.allData?.map((item) => (
                    <div
                        className={`${
                            !this.props.fromOnboard ? 'card' : ''
                        } table-main rounded-main purchase-container-item`}
                        key={item.object_name}
                    >
                        <div
                            className={`purchase-container-item-header ${this.showOpened(
                                item.object_name,
                                'show',
                            )}`}
                            onClick={() =>
                                !this.state.isFinished ? this.onClickOnStep(item.object_name) : null
                            }
                        >
                            {item.object_title}
                            <button className="arrow-icon">
                                <i className="icon-chevron-right" />
                            </button>
                        </div>
                        <div
                            className={`purchase-container-item-body ${this.showOpened(
                                item.object_name,
                                'show',
                            )}`}
                        >
                            {item.object_name === 'commerce_analytics' ? (
                                <CustomView item={item} csrf_token={this.props.csrf_token} />
                            ) : (
                                <PurchaseMoreEntity
                                    item={item}
                                    csrf_token={this.props.csrf_token}
                                />
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default PurchaseMoreEntityContainer;
